/** Issues page copy. EN mirrors SV until translated. */
export const pagesIssuesSv = {
    noIssuesFound: 'Inga emissioner hittades',
    details: {
        cancelledPrefix: 'Avbruten: ',
        cancelledNotice:
            'Notera att denna emission är avbruten. Innehållet som återges nedan återspeglar den information som fanns tillgänglig för marknaden.',
        announcedNotCompleted:
            'Denna emission är aviserad men ännu <strong>inte flaggad som genomförd</strong>. Det kan exempelvis bero på att en bolagsstämma krävs eller att det rör sig om en avsiktsförklaring.',
        importantDates: 'Viktiga datum',
        noDatesYet: 'Inga datum är angivna ännu',
        notAvailable: 'N/A',
    },
    publicStatus: {
        statusLabel: 'Status:',
        cancelled: 'Avbruten',
        upcomingMissingTerms: 'Kommande, villkor saknas',
        completed: 'Genomförd',
        btaBtuTrading: 'Handel i BTA/BTU pågår',
        subscriptionPeriodEnded: 'Teckningsperiod avslutad',
        subscriptionPeriodOngoing: 'Teckningsperioden pågår',
        upcoming: 'Kommande',
        ongoing: 'Pågående',
        announced: 'Aviserad',
        upcomingMissingTermsLong: 'Kommande emission. Aviserad utan villkor',
        subscriptionPeriodEndedWithOutcome: 'Teckningsperiod avslutad och utfall har offentliggjorts',
        subscriptionPeriodEndedWithBtaBtu: '. Handel i BTA/BTU pågår',
        subscriptionPeriodOngoingWithRightsEnd: 'Teckningsperioden pågår. Sista dagen för handel i rätter är {{date}}',
        publishedRightsDeadlinePassed: 'Offentliggjord emission. Sista dagen för att erhålla rätter var {{date}}',
        upcomingRightsDeadline: 'Kommande emission. Sista dagen för att erhålla rätter är {{date}}',
        upcomingMissingDates: 'Kommande emission. Datum saknas.',
        completedOnDate: 'Genomförd: {{date}}',
        announcedWithMeeting: 'Aviserad emission, bolagsstämma {{date}}',
        announcedIssue: 'Aviserad emission',
        subscriptionPeriodOngoingShort: 'Teckningsperiod pågår',
    },
    info: {
        title: 'Information',
        loadingTitle: 'Info',
        marketplace: 'Lista',
        financialAdvisors: 'Finansiella rådgivare',
        legalAdvisors: 'Legala rådgivare',
        issuingAgent: 'Emissionsinstitut',
    },
    comments: {
        title: 'Övrigt',
        sources: 'Källor',
        isinRights: 'ISIN Teckningsrätt',
        isinUnits: 'ISIN Unit',
        earnoutDescription: 'Emissionen avser en tilläggsköpeskilling',
        ownSharesDescription:
            'Transaktionen genomfördes med bolagets befintliga aktier istället för att emittera nya.',
        guarantorFeeSourceType: 'Garantiersättning',
    },
    related: {
        relatedIssues: 'Relaterade emissioner',
        relatedConvertibles: 'Relaterade konvertibler',
    },
    sellers: {
        title: 'Säljande aktieägare',
        owner: 'Ägare',
    },
    summary: {
        title: 'Sammanfattning',
        subscriptionPeriodMissing: 'Teckningperiod saknas',
        amountMissing: 'Belopp saknas',
        subscriptionPeriod: 'Teckningsperiod',
        publicationDate: 'Publiceringsdatum',
        notCommunicatedYet: 'Ej kommunicerat ännu',
        outcomeExpectedDate: 'Beräknas komma den {{date}}',
        estimatedDateMissing: 'Beräknat datum saknas',
        issueLabel: 'Emission',
        issueSize: 'Emissionens storlek',
    },
    underwriters: {
        title: 'Tecknings- och garantiåtagare',
        commitmentInfoNotCommunicated: 'Information om vilka som lämnat åtaganden har inte kommunicerats ännu',
        guarantorCompensations: 'Garantiersättningar:',
        noCommitment: 'Teckningsåtagande och garantiåtagande saknas',
    },
    compensation: {
        title: 'Ersättning till garantiåtagare',
        sharesCount: '{{count}} aktier',
    },
    investors: {
        title: 'Investerare',
        incompleteInfo: 'Fullständig information angående deltagare och vilka belopp har ej kommunicerats av bolaget.',
        amountWithCurrency: 'Belopp ({{currency}})',
        share: 'Andel',
        leo: 'Leo',
        yes: 'Ja',
    },
    costs: {
        title: 'Emissionskostnader (dummy)',
        issuingAgent: 'Emissionsinstitut',
        financialAdvisor: 'Finansiell rådgivare',
        legalAdvisor: 'Legal rådgivare',
        other: 'Övriga kostnader',
    },
    filters: {
        abbAll: 'Alla riktade emissioner',
        abbOnly: 'Endast ABB',
        abbExclude: 'Exkludera ABB',
        warrantsAll: 'Alla emissioner',
        warrantsOnly: 'Endast emissioner med TO',
        warrantsExclude: 'Endast emissioner utan TO',
        guarantorsAll: 'Alla emissioner',
        guarantorsOnly: 'Endast emissioner med garanter',
        guarantorsNone: 'Endast emissioner utan garanter',
        issueTermsAll: 'Alla företrädesemissioner',
        issueTermsOnly: 'Teckningskurs framgick initialt',
        issueTermsNone: 'Teckningskurs saknades initialt',
        financialAdvisor: 'Finansiell rådgivare',
        legalAdvisor: 'Legal rådgivare',
        industry: 'Bransch',
        preMoney: 'Pre-money',
        offeringSize: 'Erbjudandets storlek',
        marketplaces: 'Listor',
        unitIssues: 'Unitemissioner',
        issueTerms: 'Emissionsvillkor',
        guarantors: 'Garantiåtagare',
        bookBuilding: 'Book building',
        marketSizeToday: 'Börsvärde idag',
        marketSizePrePublication: 'Börsvärde innan emission',
    },
    terms: {
        title: 'Villkor',
        requestedAmount: 'Sökt belopp',
        requestedShares: 'Sökt antal aktier',
        publicationTimestamp: 'Tidpunkt för offentliggörande',
        closingTimestamp: 'Tidpunkt för stängning',
        conditions: 'Villkor',
        showRightsCalculator: '{{action}} TR-räknare',
        hide: 'Dölj',
        show: 'Visa',
        notDeterminedYet: 'Ej fastställt ännu',
        termsExplanation: '{{newShares}} {{newSharesLabel}} på {{existingShares}} {{existingSharesLabel}} ({{ratio}})',
        newShare: 'ny aktie',
        newShares: 'nya aktier',
        existingShare: 'befintlig',
        existingShares: 'befintliga',
        subscribeAmount: 'Teckna',
        payPremium: 'Betala premie',
        premiumTooltip: 'Beräkna rätternas prisnivå så att de motsvarar det angivna påslaget på teckningskursen',
        rightsCount: '{{count}} rätter',
        rightsWord: 'rätter',
        perRight: '/ rätt',
        subPrice: 'Teckningskurs',
        subscribedShares: 'Antal tecknade aktier',
        amount: 'Belopp',
        warrants: 'Teckningsoptioner',
        publicationDate: 'Datum (avisering)',
        outcomeDate: 'Datum (genomförande)',
        conditionalSubscriptionRate: 'Villkorad teckningsgrad',
        conditionalIssueText: 'Emissionen är villkorad att teckningsgraden uppgår till minst {{rate}}',
        warrantsNone: '(Inga)',
        offeredVolume: 'Erbjuden volym',
        newSharesIssued: 'Nya aktier som emitteras',
        volume: 'Volym',
        noNewSharesIssued: 'Inga nya aktier emitteras',
        volumeCorresponding: '{{units}}, motsvarande {{shares}}',
        unlistedSharesNote: 'Varav {{quantity}} i erbjudandet avser onoterade aktieslag.',
        secondaryOffering: 'Befintliga aktier som säljs',
        overAllotment: 'Övertilldelning',
        overAllotmentSecondary: 'Övertilldelning (befintliga aktier)',
        preMoneyTooltip: 'Pre-money = Teckningskurs x Antal aktier innan emissionen',
        preMoney: 'Pre-money',
        dilution: 'Utspädning',
        dilutionMax: '{{value}} (maximal)',
        dilutionActual: '{{value}} (faktisk)',
        newSharesMissing: 'Antal nya aktier saknas',
        shareSplit: 'Aktiesplit',
        shareSplitForward:
            'Aktiesplit den {{date}} där {{oldShares}} {{oldSharesLabel}} omvandlas till {{newShares}} {{newSharesLabel}}',
        shareConsolidation:
            'Sammanläggning av aktier den {{date}} där {{oldShares}} {{oldSharesLabel}} sammanläggs till {{newShares}} {{newSharesLabel}}',
        share: 'aktie',
        shares: 'aktier',
        bonusIssue: 'Fondemission',
        bonusIssueDescription:
            'Fondemission genomförd den {{date}} där {{oldShares}} {{oldSharesLabel}} gav {{newShares}} {{newSharesLabel}}',
        existingShareSingular: 'befintlig aktie',
        existingSharesPlural: 'befintliga aktier',
        newShareSingular: 'ny aktie',
        newSharesPlural: 'nya aktier',
        unit: 'Unit',
        warrantsPlaceholder: 'X teckningsoptioner',
        sharesPlaceholder: 'X aktier',
        nonCashConsideration: 'Apportegendom',
        units: 'units',
        sharesWord: 'aktier',
    },
    discount: {
        label: 'Rabatt',
        labelWithVwap: 'Rabatt (10d VWAP)',
        tooltipIntro: 'Rabatten beräknas från tidpunkten då emissionen offentliggjordes.',
        tooltipTerp: 'TERP-rabatt avser rabatten mot det teoretiska priset på aktien exklusive rätter.',
        tooltipFormula:
            'TERP = (Market cap + Antal nya aktier vid fullteckning * Teckningskurs) / (Maximalt antal aktier efter fulltecknad emission)',
        timePeriod: 'Tidsperiod',
        sharePrice: 'Aktiekurs',
        discount: 'Rabatt',
        terp: 'TERP',
        fromPublication: 'Från offentliggörande av emission',
        fromTermsDate: 'Från det datum aktiekursen bestämdes',
        oneDayClose: '{{count}} dag stängningskurs',
        daysVwap: '{{count}} dagar VWAP',
        notAvailable: 'Ej tillgängligt',
        vsSharePrice: 'mot aktiekursen',
        vsTerp: 'mot TERP',
        cannotCalculate: 'Rabatter kan inte beräknas',
    },
    tradingStats: {
        title: 'Handelsstatistik',
        notStarted: 'Handel ej inledd ännu',
        overview: 'Övergripande',
        rights: 'Rätter',
        timePoint: 'Tidpunkt',
        vwap: 'VWAP',
        turnoverPerDay: 'Omsättning / dag ({{currency}})',
        totalQuantity: 'Totalt antal',
        daysBeforePublication: '{{days}}d innan offentliggörande',
        betweenPublicationAndTerms: 'Mellan offentliggörande och villkor',
        duringSubscriptionPeriod: 'Under teckningsperioden',
        duringBtaBtuTrading: 'Under handel med BTA/BTU',
        firstTradingDay: 'Första handelsdag',
        firstTradingDays: 'Första {{days}} handelsdagarna',
        unitTrading: 'Handeln i {{symbol}}',
        shareSplitAdjustment:
            'På grund av genomförd aktiesplit under perioden har VWAP och Totalt antal justerats med hänsyn till splitten.',
        unitsToSharesNote: '* = Omräknat från units till aktier',
        rightsNotStarted: 'Rätterna har inte börjat handlas än.',
        rightsStartDate: 'Rätterna börjar handlas den {{date}}',
        totalRights: 'Totalt antal rätter',
        approxRightsExclTa: 'Ungefärligt antal rätter exkl TÅ',
        tradedRightsOngoing: 'Omsatta rätter hittills',
        tradedRightsTotal: 'Omsatta rätter totalt',
        tradedRightsLastDay: 'Omsatta rätter sista handelsdagen',
        lastDay: 'Sista dagen: {{date}}',
        rightsVwapTotal: 'Rätternas VWAP totalt',
        rightsVwapLastDay: 'Rätternas VWAP sista handelsdagen',
        ofPricePerShare: 'av priset per ny aktie',
        ofPricePerUnit: 'av priset per unit',
        ofAvailableRights: 'av tillgängliga rätter',
    },
    outcome: {
        title: 'Utfall',
        subscriptionRate: 'teckningsgrad',
        subscribed: 'Tecknat',
        percent: 'Procent',
        countUnits: 'Antal units',
        countShares: 'Antal aktier',
        amount: 'Belopp',
        withRights: 'Med företräde',
        withoutRights: 'Utan företräde',
        byGuarantors: 'Av garanter',
        bySubscribers: 'Av teckningsåtagare',
        byPublic: 'Av allmänheten',
        overAllotment: 'Övertilldelning',
        chartWithRights: 'Tecknat med företräde',
        chartWithoutRights: 'Tecknat utan företräde',
        chartByGuarantors: 'Tecknat av garanter',
        chartNotSubscribed: 'Ej tecknat',
        chartBySubscribers: 'Tecknat av teckningsåtagare',
        chartByPublic: 'Tecknat av allmänheten',
        totalSubscribed: 'Totalt tecknades {{quantity}} för {{amount}}',
        subscriptionRateBreakdown:
            'Teckningsgraden uppgick till {{totalRate}} varav {{withRightsRate}} av erbjudandet tecknades med stöd av rätter och {{withoutRightsRate}} utan stöd av rätter.',
        guarantorsSubscribed:
            'Garantiåtagare tecknade {{pctOfOffer}} av erbjudandet, motsvarande {{pctOfIssued}} av emitterat antal aktier, eller {{pctOfGuaranteed}} av det garanterade beloppet.',
        overAllotmentUsed: 'Övertilldelningen om max {{maxQuantity}} nyttjades {{usage}}.',
        overAllotmentSecondaryUsed:
            'Övertilldelningen om max {{maxQuantity}} befintliga aktier (secondary) nyttjades {{usage}}.',
        notUsed: 'inte',
        usedTo: 'till {{quantity}}',
        secondaryOfferingUsed: 'Av de befintliga {{offered}} som erbjöds (secondary) nyttjades {{subscribed}}.',
    },
    feeLevels: {
        subscriber: 'Teckningsåtagare',
        subscription: 'Teckningsåtagande',
        guarantor: 'Garantiåtagare',
        guarantorCommitment: 'Garantiåtagande',
        bottomGuarantee: 'Bottengaranti',
        topGuarantee: 'Toppgaranti',
        level: 'Nivå {{level}}',
        subscriptionWithoutRights: 'TÅ utan rätter',
        notGuaranteed: 'Ej säkerställt',
        totalCommitment: 'Totalt åtagande',
    },
    quantityLabels: {
        right: 'rätt',
        rights: 'rätter',
        share: 'aktie',
        shares: 'aktier',
        unit: 'unit',
        units: 'units',
        warrant: 'teckningsoption',
        warrants: 'teckningsoptioner',
    },
    subPriceLabel: {
        ipoInterval: '{{low}} - {{high}} {{currency}} / {{label}} ({{interval}})',
        interval: 'intervall',
        perLabel: '{{price}} / {{label}}',
        unitWithShareConversion: '{{unitPrice}} / {{unit}}.\n{{equivalent}} {{sharePrice}} / {{share}}.',
        equivalent: 'Motsvarande',
        perShare: '{{price}} per {{share}}',
        perUnit: '{{price}} per {{unit}}',
    },
    shareNameHint: {
        atIpo: 'Vid tidpunkten för börsintroduktionen hette aktien {{name}}.',
        atIssue: 'Vid tidpunkten för emissionen hette aktien {{name}}.',
    },
}
